module.exports = __webpack_public_path__ + "img/policies-shield.5c6cbdc3.png";